module.exports = __webpack_public_path__ + "img/abstract-1.a903227b.webp";